import {
  greyThemeLight,
  lightGrey,
  greyThemeLighter,
  accessibilityColors,
  smallDesktopWidth,
} from '@edulastic/colors'
import styled from 'styled-components'
import { Popover, Row, Typography, Col } from 'antd'

export const StyledPopoverContainer = styled(Popover)`
  @media (max-width: ${smallDesktopWidth}) {
    border: none;
    background-color: transparent;
  }

  border: 1px solid ${greyThemeLight};
  background-color: ${greyThemeLighter};
  border-radius: 2px;
  padding: 4px 12px;
  font-size: 18px;
  line-height: 38px;
  cursor: pointer;
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blueHover};
  }
`

export const StyledDropdownContainer = styled.span`
  padding: 0px 12px;
`

export const StyledPencilIconContainer = styled.span`
  padding: 0px 3px 0px 3px;
  margin-left: 8px;

  &:hover {
    opacity: 0.8;
  }
`

export const StyledInfoContainer = styled(Row)`
  background: ${lightGrey};
  padding: 4px 6px;
`

export const IconContainer = styled.div`
  border-radius: 50%;
  padding: 10px 12px;
  background: ${lightGrey};
  height: 40px;
  width: 40px;
  border: 1px solid #eeeeee;
`

export const StyledInfoTextContainer = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 600;
  color: black;
`

export const StyledQuestionTypeContainer = styled(Col)`
  height: 40px;
  margin-bottom: 12px;
  cursor: pointer;
`

export const StyledPopoverContentContainer = styled.div`
  max-width: 416px;
  margin: -12px -16px;
`

export const StyledQuestionTypeList = styled.ul`
  padding: 16px;
  list-style: none;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0;
`

export const StyledQuestionTypeListItem = styled.li`
  width: 50%;
  min-height: 40px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`

export const StyledQuestionTypeItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: -4px;
  cursor: pointer;
`

export const StyledIconWrapper = styled.div`
  flex: 0 0 25%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledQuestionTypeItemText = styled.div`
  flex: 1;
  padding-left: 8px;
  padding-right: 8px;
`

export const StyledChildrenContainer = styled.span`
  @media (max-width: 480px) {
    width: 48px;
    display: inline-block;
    vertical-align: top;
    line-height: 38px;
  }
`

export const StyledChangeQTypeButton = styled.span`
  @media (max-width: 480px) {
    display: flex;
    align-items: center;
  }
`
